import _classCallCheck from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import cx from 'classnames2';
import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import styles from './ReorderableBlockListItem.scss';
export var ReorderableBlockListItem = /*#__PURE__*/function (_React$Component) {
  _inherits(ReorderableBlockListItem, _React$Component);

  var _super = _createSuper(ReorderableBlockListItem);

  function ReorderableBlockListItem() {
    _classCallCheck(this, ReorderableBlockListItem);

    return _super.apply(this, arguments);
  }

  _createClass(ReorderableBlockListItem, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          id = _this$props.id,
          index = _this$props.index,
          label = _this$props.label,
          dataTest = _this$props.dataTest,
          selected = _this$props.selected,
          isDraggingOver = _this$props.isDraggingOver;
      return React.createElement("div", {
        className: cx(styles.container, isDraggingOver && styles.activeContainer)
      }, React.createElement("div", {
        className: styles.paddingContainer
      }, React.createElement(Draggable, {
        key: id,
        draggableId: id,
        index: index
      }, function (provided, snapshot) {
        return React.createElement("div", Object.assign({
          role: "button",
          className: cx(styles.card, snapshot.isDragging && styles.isDragging, selected && styles.selected),
          ref: provided.innerRef,
          onClick: _this.props.onClick,
          "data-test": dataTest
        }, provided.draggableProps, provided.dragHandleProps), React.createElement("span", {
          className: styles.cardContent
        }, label), React.createElement("div", null, React.createElement("div", {
          className: styles.dragHandle
        })));
      })));
    }
  }]);

  return ReorderableBlockListItem;
}(React.Component);